<div class="progress-info">
    <div class="help" *ngIf="info.type == InfoType.HELP">
        <div [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.help.click'"></div>
        <div [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.help.cursor'"></div>
    </div>
    <div class="info" *ngIf="info.type == InfoType.OVERVIEW">
        <div class="col col1 _noSeparator">
            <div *ngIf="info.time1" [class._hasShortBrother]="info.time2">
                <div class="title">
                    <i class="fa-fw fa fa-industry"></i>
                    <span [i18n]="'realtime-tracking.load-tracking-overview.deadline'"></span>
                </div>
                <app-timezone-date
                    [dateFormat]="dateFormat"
                    [displayBothDates]="true"
                    [time]="info.time1">
                </app-timezone-date>
            </div>
            <div *ngIf="info.time2">
                <div class="title" *ngIf="info.etaSource !== EtaEmitter.CMBL_AUTOMATIC_ETA">
                    <i class="fa-fw fa fa-truck" ></i>
                    <span [i18n]="'realtime-tracking.load-tracking-overview.provided-eta'"></span>
                </div>
                <div class="title" *ngIf="info.etaSource === EtaEmitter.CMBL_AUTOMATIC_ETA">
                    <i class="fa-fw fa fa-clock-o"></i>
                    <span [i18n]="'realtime-tracking.load-tracking-overview.projected-eta'"></span>
                </div>
                <app-timezone-date
                    [dateFormat]="dateFormat"
                    [displayBothDates]="true"
                    [time]="info.time2">
                </app-timezone-date>
            </div>
        </div>
    </div>
    <div class="info" [ngClass]="[info.type | lowercase]" *ngIf="info.type === InfoType.MOVING || info.type === InfoType.STANDSTILL || info.type === InfoType.WAITING ||
        info.type === InfoType.HANDOVER || info.type === InfoType.STANDBY || info.type === InfoType.NO_DATA">
        <div class="col col1">
            <div class="title" *ngIf="info.type === InfoType.HANDOVER"
                 [i18n]="'realtime-tracking.common.load-handover.'+(info.type | lowercase)"></div>
            <div class="title" *ngIf="info.type !== InfoType.HANDOVER"
                 [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.'+(info.type | lowercase)"></div>
            <div class="content">
                <div class="logo"></div>
                <div class="from-to">
                    <span [i18n]="'time.from'"></span>
                    <span [i18n]="'time.to'"></span>
                </div>
                <div class="data blue">
                    <app-timezone-date
                        [dateFormat]="dateFormat"
                        [displayBothDates]="true"
                        [time]="info.time1">
                    </app-timezone-date>
                    <app-timezone-date
                        [dateFormat]="dateFormat"
                        [displayBothDates]="true"
                        [time]="info.time2">
                    </app-timezone-date>
                </div>
            </div>
        </div>
        <div class="col col2">
            <div class="title" *ngIf="info.type !== InfoType.HANDOVER"
                 [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.common.duration'"></div>
            <div class="title text-capitalize" *ngIf="info.type === InfoType.HANDOVER" [i18n]="'time.by'"></div>
            <div class="content" *ngIf="info.type !== InfoType.HANDOVER">
                <span class="blue">{{ info.duration }}</span>
                <span class="blue"
                      *ngIf="info.type === InfoType.MOVING || info.type === InfoType.NO_DATA">{{ info.distance | number: '1.0-3' }} {{ distanceUnit }}</span>
            </div>
            <div class="content" *ngIf="info.type === InfoType.HANDOVER">
                <span class="blue">{{ info.handoverVehicle1 }}</span>
                <span class="blue">{{ info.handoverVehicle2 }}</span>
            </div>
        </div>
        <div class="col col3" *ngIf="info.type === InfoType.HANDOVER">
            <div class="title" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.common.duration'"></div>
            <div class="content">
                <span class="blue">{{ info.duration }}</span>
            </div>
        </div>
    </div>
    <div class="handover-event info"
         *ngIf="info.type === InfoType.HANDOVER_RELEASE || info.type === InfoType.HANDOVER_TAKE">
        <div class="col col2">
            <div class="title" [i18n]="'realtime-tracking.common.load-handover.'+(info.type | lowercase)"></div>
            <div class="content">
                <div>
                    <span class="text-capitalize" [i18n]="'time.by'"></span>&nbsp;
                    <span class="blue"
                          *ngIf="info.type === InfoType.HANDOVER_RELEASE">{{ info.handoverVehicle1 }}</span>
                    <span class="blue" *ngIf="info.type === InfoType.HANDOVER_TAKE">{{ info.handoverVehicle2 }}</span>
                </div>
                <div>
                    <span class="text-capitalize" [i18n]="'time.on'"></span>&nbsp;
                    <div class="blue" *ngIf="info.type === InfoType.HANDOVER_RELEASE">
                        <app-timezone-date
                            [dateFormat]="dateFormat"
                            [displayBothDates]="true"
                            [time]="info.time1">
                        </app-timezone-date>
                    </div>

                    <div class="blue" *ngIf="info.type === InfoType.HANDOVER_TAKE">
                        <app-timezone-date
                            [dateFormat]="dateFormat"
                            [displayBothDates]="true"
                            [time]="info.time2">
                        </app-timezone-date>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="check-event info" *ngIf="info.type === InfoType.CHECKIN || info.type === InfoType.CHECKOUT">
        <div class="col col2">
            <div class="title" [i18n]="'realtime-tracking.common.'+(info.type | lowercase)"></div>
            <div class="content">
                <div>
                    <span class="text-capitalize" [i18n]="'time.on'"></span>&nbsp;
                    <div class="blue">
                        <app-timezone-date
                            [dateFormat]="dateFormat"
                            [displayBothDates]="true"
                            [time]="info.time1">
                        </app-timezone-date>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="eta info" *ngIf="info.type === InfoType.ETA || info.type === InfoType.ETA_LATE ||
     info.type === InfoType.ETA_ON_TIME || info.type === InfoType.REMAIN">
        <div class="col col1 _noSeparator" *ngIf="info.type !== InfoType.ETA_LATE && info.type !== InfoType.ETA_ON_TIME && etaInfos">
            <div class="title" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.common.remaining'"></div>
            <div class="content">
                <span [i18n]="'realtime-tracking.common.last-ping'"></span>
                <span class="blue"
                      [title]="etaInfos.lastPingToNow">{{ etaInfos.lastPing | formatDate: 'dddd, MMMM D [at] LT' }}</span>
            </div>
        </div>
        <div class="col col2 _hasShortBrother">
            <ng-container *ngIf="info.time1">
                <div class="title"
                     *ngIf="type === TimelineEventType.PRIMARY_ETA_LATE || type === TimelineEventType.PRIMARY_ETA_ON_TIME"
                     [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.primary-'+(info.type | lowercase)"></div>
                <div class="title"
                     *ngIf="type !== TimelineEventType.PRIMARY_ETA_LATE && type !== TimelineEventType.PRIMARY_ETA_ON_TIME"
                     [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.eta-event'"></div>
            </ng-container>


            <div class="title" *ngIf="!info.time1"
                 [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.unknown'"></div>


            <div class="content" *ngIf="info.type != InfoType.REMAIN">
                <div class="flex-row m-b-sm">
                    <div class="text-capitalize m-r-sm" [i18n]="'eta-details.eta'"></div>&nbsp;
                    <div class="blue">
                        <app-timezone-date
                            [dateFormat]="dateFormat"
                            [displayBothDates]="true"
                            [time]="info.time1">
                        </app-timezone-date>
                    </div>
                </div>

                <div class="m-b-sm">
                    <span [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.common.provider'"></span>&nbsp;
                    <span class="blue">{{ info.provider }}</span>
                </div>


                <div class="flex-row">
                    <div class="text-capitalize" [i18n]="'time.on'"></div>&nbsp;
                    <div class="blue m-l-sm">
                        <app-timezone-date
                            [dateFormat]="dateFormat"
                            [displayBothDates]="true"
                            [time]="info.time2">
                        </app-timezone-date>
                    </div>
                </div>
            </div>
            <div class="content remain" *ngIf="info.type === InfoType.REMAIN && info.time1">
                <div>
                    <span class="text-capitalize" [i18n]="'time.between'"></span>&nbsp;
                    <div class="blue">
                        <app-timezone-date
                            [dateFormat]="dateFormat"
                            [displayBothDates]="true"
                            [time]="info.time1">
                        </app-timezone-date>
                    </div>

                </div>
                <div>
                    <span class="text-capitalize" [i18n]="'time.and'"></span>&nbsp;
                    <div class="blue">
                        <app-timezone-date
                            [dateFormat]="dateFormat"
                            [displayBothDates]="true"
                            [time]="info.time2">
                        </app-timezone-date>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="end info" *ngIf="info.type === InfoType.END || info.type === InfoType.END_TRIP">
        <div class="col col1">
            <div class="title" *ngIf="info.type === InfoType.END"
                 [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.end'"></div>
            <div class="title" *ngIf="info.type === InfoType.END_TRIP"
                 [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.legend.end-trip'"></div>
            <div class="content">
                <div class="logo"></div>
                <div class="from-to">
                    <span *ngIf="info.type === InfoType.END" [i18n]="'realtime-tracking.common.last-ping'"></span>
                    <span *ngIf="info.type === InfoType.END_TRIP"
                          [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.common.started'"></span>
                    <span *ngIf="info.type === InfoType.END"
                          [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.common.end'"></span>
                    <span *ngIf="info.type === InfoType.END_TRIP"
                          [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.common.finished'"></span>
                </div>
                <div class="data">
                    <div class="blue">
                        <app-timezone-date
                            [dateFormat]="dateFormat"
                            [displayBothDates]="true"
                            [time]="info.time1">
                        </app-timezone-date>
                        <app-timezone-date
                            [dateFormat]="dateFormat"
                            [displayBothDates]="true"
                            [time]="info.time2">
                        </app-timezone-date>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col2">
            <div class="title" [i18n]="'realtime-tracking.load-tracking-map.trip-timeline.common.duration'"></div>
            <div class="content">
                <span class="blue">{{ info.duration }}</span>
            </div>
        </div>
    </div>
</div>
